<template>
  <div class="awardsList" v-if="awardsList">
    <AwardItem
      v-for="awardData in awardsList"
      :awardData="awardData"
      :key="awardData.id"
      @reportEvent="handleReportEvent"
    />
    <div class="empty" v-if="!awardsList.length">
      <div class="icon"></div>
      <div>您还没有任何奖励哦～</div>
      <div class="goHomeBtn" @click="handleGoHome">去参加活动</div>
    </div>
    <div class="noMore" v-if="awardsList.length">
      没有更多了~
    </div>
  </div>
</template>

<script>
import AwardItem from './AwardItem';
import { mapState, mapGetters } from 'vuex';

export default {
  components: { AwardItem },
  computed: {
    ...mapState('app/myAwards', {
      awardsList: state => state.awardsList
    }),
    isHasUserAddress() {
      return this.checkIsHasUserAddress();
    }
  },
  watch: {
    awardsList(newVal, oldVal) {
      if (!oldVal && newVal) {
        this.reportExpo();
      }
    }
  },
  methods: {
    ...mapGetters('app/myAwards', ['checkIsHasUserAddress']),
    handleGoHome() {
      this.$router.push('/');
      this.$emit('reportEvent', {
        event: 'invite_boost_coupon_reward_click',
        module_name: '我的奖励-缺省页',
        button_name: '去参加活动'
      });
    },
    handleReportEvent(data) {
      this.$emit('reportEvent', data);
    },
    reportExpo() {
      if (this.awardsList.length) {
        const coupon_list = this.awardsList.map(item => item.rewardCode);
        this.$emit('reportEvent', {
          event: 'invite_boost_coupon_reward_expo',
          module_name: '我的奖励页',
          coupon_list
        });
      } else {
        this.$emit('reportEvent', {
          event: 'invite_boost_coupon_reward_expo',
          module_name: '缺省页'
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.awardsList {
  box-sizing: border-box;
  padding: 24px;
  width: 100%;

  .empty {
    margin-top: 220px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .icon {
      margin-bottom: 107px;
      width: 287px;
      height: 185px;
      background: center / cover no-repeat url('../../assets/images/empty.png');
    }
  }

  .noMore {
    margin: 30px 0;
    text-align: center;
  }

  .goHomeBtn {
    margin-top: 30px;
    width: 450px;
    height: 88px;
    background: linear-gradient(to top, #ff0044 0%, #ff4153 38%, #fd515f 99%);
    border-radius: 44px;
    .fc;
    color: #fff;
    font-size: 36px;
  }
}
</style>
